import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IGroupsDetailed } from '../types/groupsDetailed'
import { sortArrayOfObjects } from '../services/sort'

export const selectGroupsDetailed = createSelector(
  [(state: AppStateType) => state.groupsDetailed],
  (groupsDetailed: IGroupsDetailed) => groupsDetailed
)

export const selectGroupsDetailedList = createSelector(
  selectGroupsDetailed,
  ({ list }) => list
)

const createSortedGroupsDetailedSelector = (sortedField: string) =>
  createSelector(
    selectGroupsDetailed,
    ({ list, ...mediaTypesProps }: IGroupsDetailed) => ({
      ...mediaTypesProps,
      list: [...sortArrayOfObjects(list, sortedField)],
    })
  )

export const selectGroupsByOrder = createSortedGroupsDetailedSelector('order')
